import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-public-csat-feedback',
  templateUrl: './public-csat-feedback.component.html',
  styleUrls: ['./public-csat-feedback.component.css']
})
export class PublicCsatFeedbackComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
